import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('roleMultiSelectPanelField');

    return {
        SEARCH: t('search')
    };
};

export default useTranslation;
